<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const isEnabled = ref(false);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { features = {} } = currentAccount.value || {};
    isEnabled.value = !!features.strict_agent_visibility;
  },
  { deep: true, immediate: true }
);

const toggleVisibility = async () => {
  try {
    await updateAccount({ strict_agent_visibility: isEnabled.value });
    useAlert(
      t('GENERAL_SETTINGS.FORM.STRICT_AGENT_VISIBILITY.API.SUCCESS')
    );
  } catch (error) {
    useAlert(
      t('GENERAL_SETTINGS.FORM.STRICT_AGENT_VISIBILITY.API.ERROR')
    );
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.STRICT_AGENT_VISIBILITY.TITLE')"
    :description="
      t('GENERAL_SETTINGS.FORM.STRICT_AGENT_VISIBILITY.NOTE')
    "
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggleVisibility" />
      </div>
    </template>
  </SectionLayout>
</template>
